import { ToolBase } from "./_helpers";
/** The logic for the DC Power calculator */
export class ResistorColourCalculator extends ToolBase {
    constructor() {
        super("tools-resistor-colour");
        this.colours = ["black", "brown", "red", "orange", "yellow", "green", "blue", "violet", "grey", "white", "gold", "silver", ""];
        this.tolerances = ["±20%", "", "±1%", "±2%", "±0.05%", "±0.02%", "±0.5%", "±0.25%", "±0.1%", "", "", "±5%", "±10%"];
        this.temps = ["250", "100", "50", "15", "25", "20", "10", "5", "1"];
    }
    onLoad() {
        this.bandCountSelect = this.loadSelect('select-band-count');
        this.band1Select = this.loadSelect('select-band-1');
        this.band2Select = this.loadSelect('select-band-2');
        this.band3Select = this.loadSelect('select-band-3');
        this.multiplierSelect = this.loadSelect('select-multiplier');
        this.toleranceSelect = this.loadSelect('select-tolerance');
        this.temperatureSelect = this.loadSelect('select-temperature');
        this.onChange();
    }
    bandsToValue(band1, band2, multiplier) {
        let val = (band1 * 10) + band2;
        val *= multiplier;
        let resistorValue = `${this.formatNumber(val)}Ω`;
        let tolerance = +this.toleranceSelect.value;
        let temp = +this.temperatureSelect.value;
        let toleranceText = tolerance != 0 ? `a tolerance of ${this.tolerances[tolerance + 1]}` : undefined;
        let tempText = temp != -1 ? `a temperature coefficient of ${this.temps[temp]} ppm/K` : undefined;
        let postText = "With ";
        if (toleranceText != undefined) {
            postText += toleranceText;
            if (tempText != undefined)
                postText += " and ";
        }
        if (tempText != undefined)
            postText += tempText;
        let result = {
            result: resistorValue,
            pre: "Your resistor is",
            post: toleranceText != undefined || tempText != undefined ? postText : undefined
        };
        this.showResult(result);
    }
    onChange() {
        // Update enablement based on band count
        let bandCount = +this.bandCountSelect.value;
        this.band3Select.disabled = bandCount < 5;
        this.toleranceSelect.disabled = bandCount < 4;
        this.temperatureSelect.disabled = bandCount < 6;
        // Set value to default if disabled
        if (this.band3Select.disabled)
            this.band3Select.value = "-1";
        if (this.toleranceSelect.disabled)
            this.toleranceSelect.value = "-1";
        if (this.temperatureSelect.disabled)
            this.temperatureSelect.value = "-1";
        // Load the values from the selects
        let b1 = +this.band1Select.value;
        let b2 = +this.band2Select.value;
        let b3 = +this.band3Select.value;
        let m = +this.multiplierSelect.value;
        let to = +this.toleranceSelect.value;
        let te = +this.temperatureSelect.value;
        // Update the GUI colours
        this.colourBand("res_BandA", this.getColourForValue(b1));
        this.colourBand("res_BandB", this.getColourForValue(b2));
        this.colourBand("res_BandC", this.getColourForValue(b3));
        this.colourBand("res_BandD", this.getColourForValue(m));
        this.colourBand("res_BandTo", this.getColourForValue(to));
        this.colourBand("res_BandTe", this.getColourForValue(te));
        let multiplier = Math.pow(10, m);
        if (m == 10)
            multiplier = 0.1;
        else if (m == 11)
            multiplier = 0.01;
        if (b1 < 0 || b2 < 0 || m < 0)
            return;
        this.bandsToValue(b1, b2, multiplier);
    }
    getColourForValue(val) {
        if (val >= 0)
            return this.colours[val];
        return "transparent";
    }
    colourBand(id, colour) {
        document.getElementById(id).setAttribute("fill", colour);
    }
    /** Formats a number to have a suffix and remove the extra 0s */
    formatNumber(num) {
        let formattedNumber;
        if (num >= 1e9)
            formattedNumber = (num / 1e9).toFixed(1) + 'G';
        else if (num >= 1e6)
            formattedNumber = (num / 1e6).toFixed(1) + 'M';
        else if (num >= 1e3)
            formattedNumber = (num / 1e3).toFixed(1) + 'K';
        else
            formattedNumber = num.toFixed(1).toString();
        return formattedNumber.replace(/\.0([KM]?)/, '$1');
    }
}
;
